import { useCallback } from "react";
import { useScheduleRules } from "../../../components/ScheduleEmail/hooks/useScheduleRules";

export const useFormData = () => {
  const { getScheduleRules } = useScheduleRules();

  const getFormData = useCallback(
    (data: any, scheduleValues?: any) => {
      const request: any = {};

      for (const [key, value] of Object.entries(data)) {
        if (value === undefined || value === null) {
          continue;
        }

        if (key === "attachments") {
          const fileItemIds: string[] = [];

          data.attachments.forEach((item: any) => fileItemIds.push(item.response));

          request.fileItemIds = fileItemIds;

          continue;
        }

        request[key] = data[key];
      }

      const scheduleRules = getScheduleRules(scheduleValues);

      return { ...request, scheduleRules };
    },
    [getScheduleRules]
  );

  return { getFormData };
};
